"use strict";
exports.__esModule = true;
exports.Viewer3DEnvironmentBuilder = exports.Viewer3DEnvironment = exports.Viewer3DTonemappingOperator = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var Design_1 = require("./Design");
var Viewer3DTonemappingOperator;
(function (Viewer3DTonemappingOperator) {
    Viewer3DTonemappingOperator["LINEAR"] = "LINEAR";
    Viewer3DTonemappingOperator["ACES"] = "ACES";
    Viewer3DTonemappingOperator["ACES2"] = "ACES2";
})(Viewer3DTonemappingOperator = exports.Viewer3DTonemappingOperator || (exports.Viewer3DTonemappingOperator = {}));
var Viewer3DEnvironment = /** @class */ (function () {
    function Viewer3DEnvironment() {
    }
    Viewer3DEnvironment.hasHDRIDefined = function (viewer3DEnvironment) {
        return Viewer3DEnvironment.getHDRI(viewer3DEnvironment) !== core_common_domain_1.Media.UNDEFINED;
    };
    Viewer3DEnvironment.getHDRI = function (viewer3DEnvironment) {
        return viewer3DEnvironment.viewer3DConfig.viewerIblEnvironmentConfig.hdri;
    };
    return Viewer3DEnvironment;
}());
exports.Viewer3DEnvironment = Viewer3DEnvironment;
var Viewer3DEnvironmentBuilder = /** @class */ (function () {
    function Viewer3DEnvironmentBuilder(viewer3DEnvironment) {
        this.viewer3DEnvironment = viewer3DEnvironment;
    }
    Viewer3DEnvironmentBuilder.initialiseWithViewer3DEnvironment = function (viewer3DEnvironment) {
        return new Viewer3DEnvironmentBuilder(viewer3DEnvironment);
    };
    Viewer3DEnvironmentBuilder.initialiseWithDefaultsWithoutHDRI = function () {
        return new Viewer3DEnvironmentBuilder({
            defaultPointOfView3D: core_common_domain_1.PointOfView3D.defaultPointOfView3D,
            viewer3DConfig: {
                viewerIblEnvironmentConfig: {
                    rotation: 0,
                    exposure: 0,
                    saturation: 0.8,
                    contrast: 1.1,
                    hdri: core_common_domain_1.Media.UNDEFINED,
                    tonemapping: Viewer3DTonemappingOperator.ACES
                },
                viewerMetalConfig: {
                    roughness: 0 /* MIN */,
                    metalness: 1 /* MAX */,
                    platingColours: [
                        {
                            platingType: Design_1.PlatingType.RHODIUM,
                            hexColour: '#ffffff'
                        },
                        {
                            platingType: Design_1.PlatingType.YELLOW_GOLD,
                            hexColour: '#D4AF37'
                        },
                        {
                            platingType: Design_1.PlatingType.ROSE_GOLD,
                            hexColour: '#ba5a5a'
                        }
                    ]
                },
                viewerEngravingConfig: {
                    engravingAreaNormalScale: 0,
                    engravingAreaRoughness: 0 /* MIN */,
                    engravingAreaMetalness: 1 /* MAX */,
                    engravingRoughness: 0.75,
                    engravingColor: "#4a4a4a"
                },
                viewerStonesConfig: {
                    correctionScale: 1.8,
                    environmentIntensity: 0.6
                },
                engravingConfig: {
                    lineHeightToLineSpacingFactor: 0.1
                }
            }
        });
    };
    Viewer3DEnvironmentBuilder.prototype.withHDRIMedia = function (hdri) {
        this.viewer3DEnvironment.viewer3DConfig.viewerIblEnvironmentConfig.hdri = hdri;
        return this;
    };
    Viewer3DEnvironmentBuilder.prototype.withHDRIUrl = function (url) {
        this.viewer3DEnvironment.viewer3DConfig.viewerIblEnvironmentConfig.hdri = {
            url: url,
            contentType: core_common_domain_1.MimeType.HDRI
        };
        return this;
    };
    Viewer3DEnvironmentBuilder.prototype.withDefaultPointOfView3D = function (defaultPointOfView3D) {
        this.viewer3DEnvironment.defaultPointOfView3D = defaultPointOfView3D;
        return this;
    };
    Viewer3DEnvironmentBuilder.prototype.build = function () {
        return this.viewer3DEnvironment;
    };
    return Viewer3DEnvironmentBuilder;
}());
exports.Viewer3DEnvironmentBuilder = Viewer3DEnvironmentBuilder;
